import { Fetch } from 'lib/Fetch';

export function getCorrespondents() {
  return new Fetch('api_2')
    .url('/external/global/correspondents')
    .method('get')
    .portalToken()
    .send();
}
